<template>
  <div>
    <div class="handle">
      <el-button @click="batchDelete" :disabled="checkArray.length === 0">批量移除</el-button>
      <el-button type="primary" @click="importExcel">导入名单</el-button>
      <el-button type="primary" @click="showAddPersonModal">添加</el-button>
    </div>
    <div>
      <Table @selection-change="selectChange" :data="currentPersons" />
    </div>
    <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-sizes="[10, 50, 100, 500, 1000]"
      layout="total, sizes, prev, pager, next, jumper" :total="persons.length" background/>
    <DingMoblieImport :showImportModal="showImportModal" v-if="showImportModal.flag" @addSucceed="importSucceed"
      @closeDialog="closeImportModal" />
    <AddPerson v-if="showAddPerson.flag" :showAddPerson="showAddPerson" @addPersonHandle="addPersonHandle" @close="closeAddPerson"/>
  </div>
</template>

<script>
import Table from "./table.js";
import vue from "@/main.js";
import DingMoblieImport from "./dingMoblieImport";
import AddPerson from "./addPerson.vue";
import { Confirm } from "@/components/Confirm";
export default {
  inject: ["form"],
  components: {
    Table,
    DingMoblieImport,
    AddPerson
  },
  data() {
    return {
      checkArray: [],
      persons: [],
      currentPage: 1,
      currentSize: 10,
      currentPersons: [],
      showAddPerson: { flag: false },
      showImportModal: { flag: false }
    };
  },
  methods: {

    showAddPersonModal() {
      this.showAddPerson = {
        flag: true
      }
    },
    // 通过添加弹窗，添加单个手机号成功回调
    addPersonHandle(val) {
      const isDuplicate = this.persons.some(item => item.userMobile === val.userMobile);
      if (isDuplicate) {
        this.$message.warning(`手机号 ${val.userMobile} 已存在，请勿重复添加`);
        return;
      }
      this.showAddPerson = { flag: false };
      this.persons.splice(0, 0, val);
      this.updatePersons()
      this.$message.success('添加成功');
      this.getCurrentPersons();
    },
    
    // 导入
    importExcel() {
      this.showImportModal = { flag: true };
    },
    // 导入人员名单
    importSucceed(data) {
      let persons = data.map((ele) => {
        return {
          userMobile: ele.toUserMobile,
        };
      });
      this.persons = persons.concat(this.persons);
      let obj = {};
      this.persons = this.persons.reduce((cur, next) => {
        obj[next.userMobile] ? "" : obj[next.userMobile] = true && cur.push(next);
        return cur;
      }, [])
      this.updatePersons()
      this.getCurrentPersons();
    },


    selectChange(selections) {
      this.checkArray = selections;
    },

    getCurrentPersons() {
      console.log('---getCurrentPersons----', this.currentPage);
      this.currentPersons = this.persons.slice(
        this.currentSize * (this.currentPage - 1),
        this.currentSize * this.currentPage
      );
      console.log('---2222----', this.currentPersons);
    },
    handleSizeChange(size) {
      this.currentSize = size;
      this.getCurrentPersons();
    },
    handleCurrentChange(page) {      
      this.currentPage = page;
      this.getCurrentPersons();
    },
    // 批量删除人员
    async batchDelete() {
      const text = "确定批量删除选中的号码吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        // 批量删除
        let arrayDifference = (a, b) => {
          // 差集 a - b
          let clone = a.slice(0); // clone = a
          for (let i = 0; i < b.length; i++) {
            let temp = b[i];
            for (var j = 0; j < clone.length; j++) {
              if (temp === clone[j]) {
                clone.splice(j, 1); // remove clone[j]
              }
            }
          }
          return clone;
        };
        let filterData = (array) => {
          // 去重
          return Array.from(new Set(array));
        };
        this.persons = filterData(
          arrayDifference(this.persons, this.checkArray)
        );
        this.updatePersons()
        console.log('----1111----', this.persons);
        
        this.fixPaginationAfterDelete();
      } catch (error) {
        if (error === "cancel") return;
      }
    },

    fixPaginationAfterDelete() {
      const total = this.persons.length;
      const totalPages = Math.ceil(total / this.currentSize);
      if (this.currentPage > totalPages && totalPages > 0) {
        this.currentPage = totalPages;
      } else if (totalPages === 0) {
        this.currentPage = 1;
      }
      
      // 重新获取当前页数据
      this.getCurrentPersons();
      this.checkArray = [];
    },

    closeAddPerson() {
      this.showAddPerson = { flag: false };
    },

    closeImportModal() {
      this.showImportModal = { flag: false };
    },
    reset() {
      this.checkArray = []
      this.persons = []
      this.currentPage = 1
      this.currentSize = 10
      this.currentPersons = []
      this.updatePersons()
    },

    updatePersons() {
      this.$emit('update:personList', this.persons);
    }
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 10px;
  float: right;
}

.handle {
  text-align: right;
  margin-bottom: 10px;
}
</style>
